// ** React Imports
import { useState, useEffect } from 'react'

import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl'
import TextField from '@mui/material/TextField'
import FormHelperText from '@mui/material/FormHelperText'
import Divider from '@mui/material/Divider'
import { Autocomplete, Fab } from '@mui/material'

import { Controller, useForm } from 'react-hook-form'
import axios from 'axios'
import Swal from 'sweetalert2'
import { useNavigate, useParams } from "react-router-dom";

import Icon from '../../../../components/icon';
import apiUrl from '../../../../configs/constant';
import React from 'react';

export default function Detail() {
    const userData = JSON.parse(localStorage.getItem('user')!)
    const user = userData.data
    const token = userData.token
    const cabang = JSON.parse(localStorage.getItem('cabang')!)
    const { id } = useParams()
    const navigate = useNavigate()

    const [listAkun, setListAkun] = useState<any[]>([])
    const [listDetail, setListDetail] = useState<any[]>([])

    interface FormInputs {
        kode: string,
        nama: string,
        deskripsi: string,
        syscabang_id: any,
        detailAkun: any
    }

    const defaultValues: Partial<FormInputs> = {
        syscabang_id: cabang
    }

    const {
        control,
        handleSubmit,
        reset,
        setValue,
        formState: { errors }
    } = useForm<FormInputs>({ defaultValues })

    useEffect(() => {
        getData()
        getListAkun()
    }, [])

    const getData = () => {
        Swal.fire({
            title: 'Now loading',
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading()
            }
        })

        const url = apiUrl.apiUrl + '/mm/divisi-barang/detail/' + id
        axios
            .get(url, { headers: { Authorization: `Bearer ${token}` } })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    const detail = response.data.detail

                    setValue('syscabang_id', data.syscabang_id)
                    setValue('kode', data.kode)
                    setValue('nama', data.nama)
                    setValue('deskripsi', data.deskripsi)

                    setListDetail(detail)
                    Swal.close()
                } else {
                    Swal.fire({ title: 'Pemberitahuan', text: response.data.message, icon: 'error' })
                }
            })
    }

    const getListAkun = () => {

        const url = apiUrl.apiUrl + '/acc/account/list-combo'
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListAkun(data)
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })
    }

    useEffect(() => {
        if (listDetail.length && listAkun.length) {
            const mappedDetail = listDetail.map(item => {
                const foundAkun = listAkun.find(a => a.id === item.nilai)

                return {
                    id: item.id,
                    jenis_doc: item.jenis_doc,
                    akun: foundAkun || null
                }
            })

            reset(prev => ({
                ...prev,
                detailAkun: mappedDetail
            }))
        }
    }, [listDetail, listAkun])

    const onSubmit = (data: FormInputs) => {
        Swal.fire({
            title: 'Konfirmasi',
            text: 'Apakah anda ingin menyimpan data ini ?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Simpan'
        }).then(result => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: 'Now loading',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: () => { Swal.showLoading() }
                })

                const url = apiUrl.apiUrl + '/mm/divisi-barang/edit/' + id
                const payload = {
                    ...data,
                    detailAkun: data.detailAkun.map(d => ({
                        id: d.id,
                        jenis_doc: d.jenis_doc,
                        nilai: d.akun ? d.akun.id : null,
                        nilai_str: d.akun ? d.akun.nama : null
                    }))
                }

                axios
                    .post(url, payload, { headers: { Authorization: `Bearer ${token}` } })
                    .then(response => {
                        if (response.data.success) {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                text: response.data.message,
                                icon: 'success',
                                timer: 1000,
                                timerProgressBar: true,
                                willClose: () => {
                                    getData()
                                    getListAkun()
                                }
                            })
                        } else {
                            Swal.fire({ title: 'Pemberitahuan', text: response.data.message, icon: 'error' })
                        }
                    })
                    .catch(error => {
                        Swal.fire({ title: 'Pemberitahuan', text: error.message, icon: 'error' })
                    })
            }
        })
    }

    return (
        <Grid container spacing={6} sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
            <Grid item xl={12} md={12} xs={12}>
                <Fab variant='extended' color='primary' sx={{ '& svg': { mr: 1 } }} onClick={() => window.history.back()}>
                    <Icon icon='mdi:arrow-left' />
                    Kembali
                </Fab>
                <div className={'content-block dx-card'} style={{ padding: 20 }}>
                    <Typography variant='h5' sx={{ textAlign: 'center' }}>
                        Detail Master Divisi Barang
                    </Typography>
                    <Typography variant='body1' sx={{ textAlign: 'center' }}>
                        No. Dokumen : <b>{id}</b>
                    </Typography>
                    <Divider sx={{ my: 2 }} />
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <Grid container spacing={3}>
                            {/* KODE */}
                            <Grid item xs={12} sm={6}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1 }}>Kode</Typography>
                                <FormControl fullWidth>
                                    <Controller
                                        name='kode'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field }) => (
                                            <TextField {...field} label='Kode' error={Boolean(errors.kode)} InputLabelProps={{ shrink: true }} />
                                        )}
                                    />
                                    {errors.kode && <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>}
                                </FormControl>
                            </Grid>

                            {/* NAMA */}
                            <Grid item xs={12} sm={6}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1 }}>Nama</Typography>
                                <FormControl fullWidth>
                                    <Controller
                                        name='nama'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field }) => (
                                            <TextField {...field} label='Nama' error={Boolean(errors.nama)} InputLabelProps={{ shrink: true }} />
                                        )}
                                    />
                                    {errors.nama && <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>}
                                </FormControl>
                            </Grid>

                            {/* DESKRIPSI */}
                            <Grid item xs={12}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1 }}>Deskripsi</Typography>
                                <FormControl fullWidth>
                                    <Controller
                                        name='deskripsi'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field }) => (
                                            <TextField {...field} label='Deskripsi' multiline rows={2} error={Boolean(errors.deskripsi)} InputLabelProps={{ shrink: true }} />
                                        )}
                                    />
                                    {errors.deskripsi && <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>}
                                </FormControl>
                            </Grid>

                            {/* DETAIL AKUN */}
                            <Grid item xs={12}>
                                <Divider sx={{ my: 2 }} />
                                <Typography variant='h6' sx={{ fontWeight: 'bold', mb: 2 }}>Detail Akun</Typography>
                            </Grid>
                            {listDetail.map((rows, index) => (
                                <React.Fragment key={index}>
                                    <Grid item xs={12} sm={6}>
                                        <Typography variant='body2' sx={{ fontWeight: 'bold', mt: 2 }}>{rows.jenis_doc}</Typography>
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <FormControl fullWidth>
                                            <Controller
                                                name={`detailAkun.${index}`}
                                                control={control}
                                                render={({ field }) => (
                                                    <Autocomplete
                                                        value={field.value?.akun || null}
                                                        onChange={(_, newValue) => {
                                                            field.onChange({
                                                                id: rows.id,
                                                                jenis_doc: rows.jenis_doc,
                                                                akun: newValue
                                                            })
                                                        }}
                                                        options={listAkun}
                                                        getOptionLabel={(option) => option?.nama || ''}
                                                        isOptionEqualToValue={(opt, val) => opt.id === val?.id}
                                                        renderInput={(params) => (
                                                            <TextField {...params} label="Pilih Akun" />
                                                        )}
                                                    />
                                                )}
                                            />

                                        </FormControl>
                                    </Grid>
                                </React.Fragment>
                            ))}

                            {/* BUTTON */}
                            <Grid item xs={12}>
                                <Divider sx={{ my: 2 }} />
                                <Box sx={{ textAlign: 'center' }}>
                                    <Button variant='contained' type='submit'>SIMPAN</Button>
                                </Box>
                            </Grid>
                        </Grid>
                    </form>
                </div>
            </Grid>
        </Grid>
    )
}
